var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "392.000000pt",
    viewBox: "0 0 295.000000 392.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,392.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408 3552 l-348 -347 0 -1553 0 -1553 25 -24 24 -25 1360 0 c839 0 1369 4 1385 10 17 6 28 21 36 47 8 27 10 569 8 1896 l-3 1859 -24 19 c-23 18 -54 19 -1069 19 l-1047 0 -347 -348z m2344 191 c2 -10 2 -813 0 -1786 l-4 -1767 -1272 2 -1271 3 0 1455 0 1455 308 5 c291 5 309 6 323 24 11 16 14 76 14 316 0 163 3 300 7 303 3 4 430 7 949 7 889 0 942 -1 946 -17z m-2037 -135 c3 -18 5 -105 3 -193 l-3 -160 -192 -3 c-179 -2 -193 -1 -193 15 0 19 350 373 368 373 6 0 14 -15 17 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 2583 c-25 -32 -20 -69 12 -95 19 -17 80 -18 970 -18 696 0 955 3 971 11 30 16 37 28 37 66 0 67 59 63 -1006 63 l-963 0 -21 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 2092 c-21 -13 -34 -52 -28 -77 14 -58 -35 -55 997 -55 695 0 954 3 970 11 30 16 37 28 37 66 0 67 59 63 -1005 63 -528 0 -965 -4 -971 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 1575 c-36 -36 -26 -98 19 -115 40 -15 1900 -13 1928 1 30 16 37 28 37 65 0 68 68 64 -1003 64 -847 0 -967 -2 -981 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 1072 c-21 -13 -34 -52 -28 -77 14 -57 -20 -55 1007 -55 940 0 944 0 971 21 32 25 36 77 8 102 -17 16 -99 17 -983 17 -530 0 -969 -4 -975 -8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuc);
export default __webpack_public_path__ + "static/media/ruc.5876c8647134dc82a94c801ab389118c.svg";
export { ForwardRef as ReactComponent };